import { FC } from 'react';
import { Col, Row, Tooltip } from 'antd';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';
import V2Title from '@/common/components/Feedback/V2Title';
import { getAreaProtectionApprovalInfo } from './config';
import styles from './index.module.less';

/** 防撞店特殊申请的审批工作台详情内容。 */
const AreaProtectionApprovalDetail: FC<{
  chancePointDetail: any;
  approvalDetail: any;
}> = ({ chancePointDetail, approvalDetail }) => {
  const detail = getAreaProtectionApprovalInfo(chancePointDetail, approvalDetail);

  return <div className={styles.areaProtectionApprovalDetail}>
    <div className={styles.protectionHint}>
      <img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/protectionperiod-lock2.png`} />
      <strong>申请人请求<em>突破区域保护</em>，将机会点「{detail.chancePointName}」关联至拓店任务</strong>
      <p>该点位步行 <em>200m</em> 内存在 <em>{detail.dangerConflictCount}</em> 个受保护对象，请核对冲突详情后审批，<em>通过后申请人方可完成关联</em></p>
    </div>
    <V2Title divider type='H2' text='申请概要' />
    <Row gutter={12}>
      <Col span={12}><V2DetailItem label='申请类型' value={detail.applicationType} /></Col>
      <Col span={12}><V2DetailItem label='申请人' value={detail.applicant} /></Col>
      <Col span={12}><V2DetailItem label='提交时间' value={detail.submittedAt} /></Col>
      <Col span={12}><V2DetailItem label='机会点' value={detail.chancePointName} /></Col>
      <Col span={24}>
        <V2DetailItem
          label='申请理由'
          type='textarea'
          value={detail.applicationReason}
          textAreaRows={2}
        />
      </Col>
    </Row>

    <V2Title divider type='H2' text='防撞冲突详情(步行500m内)' className='mt-24' />
    {detail.conflicts.length ? <div className={styles.conflictCards}>
      {detail.conflicts.map((item) => <div key={item.id} className={styles.storeItem}>
        <div className={styles.storeName}>
          <Tooltip title={item.name}>
            <span className={styles.storeNameText}>{item.name}</span>
          </Tooltip>
          <span className={item.type === '门店' ? styles.storeTagDanger : styles.storeTagWarning}>{item.type === '门店' ? '正式门店-永久保护' : '机会点-区域保护'}</span>
        </div>
        <div className={styles.storeMeta}>{`步行：${item.walkingDistance}`}<span>{`保护到期：${item.protectionEndDate}`}</span></div>
      </div>)}
    </div> : <div className={styles.emptyConflict}>暂无步行 500m 内防撞冲突详情</div>}
  </div>;
};

export default AreaProtectionApprovalDetail;
